module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av271-9b7336802371c878e0f4d4e6a77e682e.jpg";